import React, { useState, useEffect } from 'react';
// import Carousel from "react-material-ui-carousel"
import { randomGeneral } from '../../functions/general';
import General from './General';
import { makeStyles } from "@material-ui/core";
import ShuffleIcon from '@material-ui/icons/Shuffle';
import IconButton from '@material-ui/core/IconButton';
import logo from "../../img/logo2.png"
const useStyles = makeStyles(theme => ({
    container: {
        // position: "absolute",
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        //  overflow: "auto",
        justifyContent: 'center',
        alignItems: 'center',
        width: '1000px',
        "@media (max-width: 770px)": {
            width: "100%"
        },
    }
}));

const RandomGeneral = () => {
    const styles = useStyles();
    const [list, setList] = useState([]);

    useEffect(() => {
        console.log('RandomGeneral');
        randomGeneral().then(res => {
            console.log(res)
            setList([...res]);
        }).catch(err => {
            console.log(err)
        }
        )
    }, []);

    const handleShuffle = () => {
        randomGeneral().then(res => {
            console.log(res)
            setList([...res]);
        }).catch(err => {
            console.log(err)
        }
        )
    }

    return (
        <div >
            <div>
                <h3>
                    투표 게시판
                    <IconButton onClick={handleShuffle}>
                        <ShuffleIcon />
                    </IconButton>
                </h3>

            </div>
            <div className={styles.container}>

                {
                    list.length > 0 ? list.map((item, index) => {
                        return (
                            <General
                                key={index}
                                _id={item._id}
                                title={item.title}
                                content={item.content}
                                date={item.date}
                                author={item.author}
                                image_urls={item.image_urls}
                                polls={item.polls}
                                comments={item.comments}
                                likes={item.likes}
                                participants_userids={item.participants_userids}
                                done={item.done}
                            />

                        )
                    }
                    )
                        :
                        <img src={logo} alt="logo"
                        // style={{width:"100%"}}
                        />
                }

            </div>
        </div>
    );
};

export default RandomGeneral;